import styled from "styled-components/native"

export const Container = styled.View`
    font-size: 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    height: 100%;
    position: relative;
    padding-left: 20;
    padding-right: 20;
`

export const Circulo = styled.View`
    width: 10px;
    height: 10px;
    border-radius: 10px;
`